import ApiRoutes from "../../../constants/api-routes";
import {ccoInstance} from "../../../service";


export const cooGetAllCategory = async (storeId, pageNo, status) =>
    ccoInstance.get(`${ApiRoutes.GET_ALL_CATEGORY}`);

